<template lang='pug'>
    v-card.documentAgentTemplate(elevation="0")
        v-card-title.text-h6.font-weight-bold.px-12 {{$t('DOCUMENT_AGENT.TEMPLATE_TITLE')}}
        v-card-text.document-agent-card-loading.d-flex.align-center.justify-center(v-if='loading')
            v-progress-circular(size='40'  indeterminate color='#14C6DE')
        v-card-text(v-else)
            v-container(fluid)
                v-row(v-if="!loading")
                    v-col.px-0(cols="12" md="6")
                        v-row(no-gutters class="align-start" justify="center")
                            v-col(cols="11")
                                v-hover(v-slot="{ hover }")
                                    v-card.document-agent-card(
                                        :class="['pa-4', 'template-card', { 'card-hover': hover || selectedAgent == 'blank' }]"
                                        @click="selectedAgent = 'blank'"
                                        :ripple="false"
                                        style="border-radius: 16px !important;"
                                    )
                                        .blank-template-inner
                                            .blank-template-plus-circle
                                                v-icon.blank-template-plus-icon mdi-plus

                                            .blank-template-title-wrap
                                                span.blank-template-title {{ $t('DOCUMENT_AGENT.BLANK_TEMPLATE') }}
                                                img.blank-template-ai-icon(:src="require('@/assets/images/template_ai_icon.svg')")
                    v-col.px-0(cols="12" md="6" v-for="doc_agent in document_agents" :key="doc_agent.id")
                        v-row(no-gutters class="align-start" justify="center")
                            v-col(cols="11")
                                v-hover(v-slot="{ hover }")
                                    v-card.document-agent-card(
                                        :class="['pa-4', 'template-card', { 'card-hover': hover || selectedAgent == doc_agent.id }]"
                                        @click="selectedAgent = doc_agent.id"
                                        :ripple="false"
                                        style="border-radius: 16px !important; "
                                    )
                                        v-row(no-gutters align="center")
                                            v-col(cols="auto")
                                                v-avatar(size="40" class="mr-3")
                                                    v-img(:src="select_icon_obj.path")
                                            v-col
                                                .template-title-wrap
                                                    span.text-subtitle-1.text-left.font-weight-medium {{ doc_agent.agent_name }}
                                                    img.template-access-icon(:src="doc_agent.is_public ? require('@/assets/images/template_public_icon.svg') : require('@/assets/images/template_private_icon.svg')")
                                        v-row.pt-2(no-gutters)
                                            div.text-body-2.text-left.grey--text.template-goal {{ doc_agent.goal }}
                                        v-row.pt-2(no-gutters)
                                            div.text-caption.text-left.grey--text {{ $t('DOCUMENT_AGENT.CREATOR') }}：{{ doc_agent.owner_name || $t('DOCUMENT_AGENT.CREATOR_ADMIN') }}
        v-card-actions.pr-12.pl-8(style='background-color: #f4f4f4; height:60px;')
                v-btn(
                    v-if="canDeleteTemplate(selectedDocAgent)"
                    color="#ED4242"
                    depressed
                    width="90"
                    height="31"
                    min-width="90"
                    style="border-radius: 4px;"
                    dark
                    @click="onDeleteBtnClick(selectedDocAgent)"
                )
                    span(style="font-size: 14px; font-weight: 600;") {{$t('GENERAL.DELETE')}}
                v-spacer
                v-btn.ml-4(
                    :ripple="false"
                    width="90"
                    height="31"
                    min-width="90"
                    color="cancel"
                    depressed
                    outlined
                    style='font-weight: 700;'
                    @click="onCancel") {{$t('GENERAL.CANCEL')}}
                v-btn.ml-4(
                    v-if="isAdmin && selectedDocAgent !== null"
                    :ripple="false"
                    width="90"
                    height="31"
                    min-width="90"
                    color="#14C6DE"
                    depressed
                    dark
                    @click="accessDialogVisible = true"
                )
                    .t-white(style="font-weight: 700;") {{ $t('WORK_AGENT.PERMISSION_SETTINGS') }}
                v-btn.ml-4(
                    :ripple="false"
                    width="90"
                    height="31"
                    min-width="90"
                    color='#14C6DE'
                    depressed
                    dark
                    @click="onConfirm")
                    v-progress-circular(v-if='addBtn_loading' indeterminate size='20')
                    .t-white(v-else style='font-weight: 700;') {{$t('GENERAL.APPLY')}}
        v-dialog(v-model='deleteTemplateDialogVisible' max-width='480' content-class='statusDialog')
            delete-template-dialog(
                v-if='templateToDelete'
                :template-name='templateToDelete.agent_name'
                @cancel='onDeleteTemplateCancel'
                @confirm='onDeleteTemplateConfirm'
            )
        v-snackbar(v-model='deleteErrorVisible' color='error' timeout='3500') {{ $t('DOCUMENT_AGENT.DELETE_TEMPLATE_FAILED') }}
        work-agent-access-dialog(
            v-if="isAdmin && selectedDocAgent"
            v-model="accessDialogVisible"
            entity-type="TEMPLATE"
            :entity-id="selectedDocAgent ? String(selectedDocAgent.id) : ''"
            :entity-name="selectedDocAgent ? selectedDocAgent.agent_name : ''"
            @updated="onAccessUpdated"
        )

</template>

<script>
import UpGPTPortalDataServices from "@/services/UpGPTPortalDataServices"
import deleteTemplateDialog from './deleteTemplateDialog.vue'
import WorkAgentAccessDialog from './workAgentAccessDialog.vue'


export default {
    props: {},
    components: {
        deleteTemplateDialog,
        WorkAgentAccessDialog,
    },
    async created(){
        await this.getDocumentAgentTemplateList();
    },
    data(){
        return{
            loading: false,
            addBtn_loading: false,
            document_agents:[],
            selectedAgent:null,
            select_icon_obj: { name: "default", path: require("@/assets/images/agent_icon/default.png") },
            connectCloudStorageDialog: false,
            deleteTemplateDialogVisible: false,
            templateToDelete: null,
            deleteErrorVisible: false,
            accessDialogVisible: false,
        }
    },
    computed: {
        isAdmin() {
            return localStorage.getItem('is_staff') === 'true';
        },
        currentUserId() {
            const user = JSON.parse(localStorage.getItem('user') || '{}');
            return user.userid ?? null;
        },
        selectedDocAgent() {
            return this.document_agents.find(a => a.id === this.selectedAgent) ?? null;
        },
    },
    methods: {
        async getDocumentAgentTemplateList(){
            this.loading = true;
            await UpGPTPortalDataServices.getDocumentAgentTemplateList().then((response) => {
                let data = response.data;
                data['icon_path'] = this.select_icon_obj;
                this.document_agents = data;

                if(this.document_agents.length > 0){
                    this.selectedAgent = this.document_agents[0].id;
                }
            })
            this.loading = false;
        },
        canDeleteTemplate(docAgent) {
            if (!docAgent) return false;
            if (this.isAdmin) return true;
            // 公開狀態以分享表為準（後端 is_public_template），與後端刪除權限檢查一致
            return !docAgent.is_public && docAgent.owner === this.currentUserId;
        },
        onAccessUpdated({ id, isPublic }) {
            // 權限對話框即時儲存後，同步更新列表的公開狀態 icon（無需重新載入整個列表）
            const agent = this.document_agents.find(a => String(a.id) === String(id));
            if (agent) this.$set(agent, 'is_public', isPublic);
        },
        onDeleteBtnClick(docAgent) {
            this.templateToDelete = docAgent;
            this.deleteTemplateDialogVisible = true;
        },
        onDeleteTemplateCancel() {
            this.deleteTemplateDialogVisible = false;
            this.templateToDelete = null;
        },
        async onDeleteTemplateConfirm() {
            const id = this.templateToDelete.id;
            try {
                await UpGPTPortalDataServices.deleteDocumentAgentTemplate(id);
                this.document_agents = this.document_agents.filter(a => a.id !== id);
                if (this.selectedAgent === id) {
                    this.selectedAgent = this.document_agents.length > 0 ? this.document_agents[0].id : null;
                }
                this.deleteTemplateDialogVisible = false;
                this.templateToDelete = null;
            } catch (e) {
                this.deleteErrorVisible = true;
            }
        },
        async onConfirm() {
            if (this.selectedAgent === 'blank') {
                this.$emit("emitDocumentAgentTemplateDialog", { blank: true });
                return;
            }
            if (this.selectedAgent) {
                this.addBtn_loading = false;
                let data = {
                    "agent_definition_id": this.selectedAgent,
                }
                await UpGPTPortalDataServices.createDocumentAgent(data).then((response) => {
                    let data = response.data;
                    this.$emit("emitDocumentAgentTemplateDialog", data);
                })
            }
        },
        onCancel() {
            this.selectedAgent = this.document_agents[0].id;
            this.$emit("emitCloseDocumentAgentTemplateDialog");
        },
        showConnectCloudStorageDialog(){
            this.connectCloudStorageDialog = true
        },
    }
}
</script>

<style scoped lang="css">
.documentAgentTemplate {
    display: flex;
    flex-direction: column;
    max-height: 80vh;
}

.documentAgentTemplate .v-card__text:not(.document-agent-card-loading) {
    overflow-y: auto;
    flex: 1 1 auto;
}

.blank-template-inner {
    /* 對齊一般卡片內容高度：標題列(40) + pt-2(8) + 說明2行(40) + pt-2(8) + 創建者(20) ≈ 116px，
       兩者皆套用 pa-4 padding，故整張卡等高 */
    min-height: 116px;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;

}

.blank-template-plus-circle {
    width: 24px;
    height: 24px;
    border: 2px solid #707070;
    border-radius: 50%;
    display: flex;
    margin-bottom: 10px;
}

.blank-template-plus-icon {
    font-size: 20px !important;
    color: #707070 !important;
}

.blank-template-title-wrap {
    position: relative;
}

.blank-template-title {
    font-size: 16px;
    font-weight: 500;
    color: #707070;
}

.blank-template-ai-icon {
    position: absolute;
    width: 24px;
    height: 24px;
    top: -12px;
    right: -30px;
}

.template-title-wrap {
    position: relative;
    display: inline-block;
    text-align: left;
}

.document-agent-card {
    text-align: left !important;
    min-height: 94px;
}

/* 說明文固定兩行（超出省略），讓每張卡高度一致：標題1行 + 說明2行 + 創建者1行 */
.template-goal {
    display: -webkit-box;
    -webkit-line-clamp: 2;
    -webkit-box-orient: vertical;
    overflow: hidden;
    line-height: 20px;
    height: 40px;
    white-space: normal;
    word-break: break-word;
}

.template-access-icon {
    position: absolute;
    width: 16px;
    height: 16px;
    top: 50%;
    transform: translateY(-50%);
    right: -22px;
}
</style>